import script from "./ModalPdfsDiseno.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPdfsDiseno.vue?vue&type=script&setup=true&lang=js"

import "./ModalPdfsDiseno.vue?vue&type=style&index=0&id=aa1a0962&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa1a0962"]])

export default __exports__